import { useMemo } from 'react';

import { useFormContext, useField } from '../../../forms/orderForm';
import { calculateBusinessDays } from '../../../helpers';
import { useOrderContext } from '../../../providers/OrderProvider';

export const useExecutionPeriodSection = () => {
  const { values } = useFormContext();

  const { helpers: executionPeriodInBusinessDaysHelpers } = useField(
    'executionPeriodInBusinessDays'
  );

  const { disabledDates, minEndDate, brokerTimezoneOffset } = useOrderContext();

  const enabledYears = useMemo(
    () => new Set(disabledDates.map((date) => date.getFullYear())),
    [disabledDates]
  );

  const onChangeEndDate = (date: Date | null) => {
    if (date && values.startDate) {
      const executionPeriodInBusinessDays = calculateBusinessDays(
        values.startDate,
        date,
        disabledDates
      );

      executionPeriodInBusinessDaysHelpers.setValue(
        executionPeriodInBusinessDays
      );
    } else {
      executionPeriodInBusinessDaysHelpers.setValue(undefined);
    }
  };

  return {
    enabledYears,
    disabledDates,
    minEndDate,
    brokerTimezoneOffset,
    onChangeEndDate,
  };
};
